import { FeatureToggleClientService } from 'feature-toggle-client';
export const DashbotAction = 'dashbot-analytics-integration';
export class DashbotActionFeatures {
    static dashbotActionApplicationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DashbotAction);
    }
}
